import { useAppSelector } from "@/utils";
import { DashboardChecksTypeEnum } from "@payping/api";

export function useIsLocalDisabled() {
  return useAppSelector((state) => state.user.checks?.localStatus === DashboardChecksTypeEnum.Confirmed);
}
